import { http } from '@/lib/http';
import type { APIResponse } from '@/types';

export type GetSiteNotificationParams = {
  oemServiceId: number;
  branchKey?: string;
  key: string;
};

export type GetNotificationResponse = APIResponse<{
  targetUrl: string;
  refererDomain: string;
  refererUrl: string;
}>;

export const getRedirectUrl = async (params: GetSiteNotificationParams) => {
  return await http<GetNotificationResponse>('/user/v1/redirect-url', {
    method: 'GET',
    query: {
      oem_service_id: params.oemServiceId,
      branch_key: params.branchKey,
      key: params.key,
    },
  });
};
